<!-- 收货地址-添加 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">收货地址</p>
		</div>

		<div class="form-row">
			<span class="form-row-label">收货人</span>
			<input class="form-row-input" type="" placeholder="收货人" name="" id="" value="" />
		</div>

		<div class="form-row">
			<span class="form-row-label">手机号码</span>
			<input class="form-row-input" type="" placeholder="请填写收货人手机号码" name="" id="" value="" />
		</div>

		<div class="form-row">
			<span class="form-row-label">所在地区</span>
			<input class="form-row-input" type="" placeholder="请选择所在地区" name="" id="" value="" />
			<img src="../assets/icon-63.png" style="width: 14px;" >
		</div>

		<div class="form-row">
			<span class="form-row-label">详细地址</span>
			<input class="form-row-input" type="" placeholder="请输入街道、楼牌号" name="" id="" value="" />
		</div>

		<div class="form-row">
			<span class="form-row-label">设为默认地址</span>
			<img src="../assets/switch.png" style="width: 48px;">
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<!-- 编辑的时候显示删除按钮 添加的时候不显示 -->
				<button type="button" class="footer-btn border">删除</button>
				<button type="button" class="footer-btn">保存</button>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 66px 15px 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 0 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 25px;
		box-sizing: border-box;
	}


	.footer-btn {
		flex: 1;
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
		box-sizing: border-box;
	}

	.footer-btn.border {
		flex: initial;
		width: 115px;
		margin-right: 15px;
		border: 1px solid #2A63F3;
		box-sizing: border-box;
		color: #2A63F3;
		background-color: #FFFFFF;
	}

	.form-row {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 25px;
	}

	.form-row-label {
		width: 109px;
		padding-left: 3px;
		box-sizing: border-box;
	}

	.form-row-input {
		flex: 1;
		font-size: 14px;
		color: #222222;
	}

	.form-row-input::placeholder {
		color: #999;
	}
</style>
